import { render, staticRenderFns } from "./MinisiteDeclareResultConfirmation.vue?vue&type=template&id=e519c898&scoped=true&"
import script from "./MinisiteDeclareResultConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisiteDeclareResultConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteDeclareResultConfirmation.vue?vue&type=style&index=0&id=e519c898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e519c898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e519c898')) {
      api.createRecord('e519c898', component.options)
    } else {
      api.reload('e519c898', component.options)
    }
    module.hot.accept("./MinisiteDeclareResultConfirmation.vue?vue&type=template&id=e519c898&scoped=true&", function () {
      api.rerender('e519c898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteDeclareResultConfirmation.vue"
export default component.exports